import { IPopup, PopupOptions } from "./popup";
import { getPopup, getCurrentLanguageId, getUrlWithoutQueryString } from "./common";
import Form from "./form";
import ConfirmDialog from "./confirm-dialog";
import HttpClient from "./http-client";
//import $ from "jquery";
//import 'jquery-validation-unobtrusive'

export interface PopupElements {
    addItemButton: HTMLButtonElement;
    editButtons: HTMLButtonElement[];
    deleteButtons: HTMLButtonElement[];
}

export interface PopupComponent {
    displayComponentName: string;
    removeItemUrl: string;
    addItemUrlParameters: QueryParameter[];
    editItemUrlParameters: QueryParameter[];
    removeItemUrlParameters: QueryParameter[];
}

interface QueryParameter {
    fieldName: string;
    // Name of data attribute where is a query parameter value stored
    dataAttributeTargetValue: string;
}

export class EditListPopup {
    private formId: string;
    private popup: IPopup;
    private popupElements: PopupElements;
    private popupComponent: PopupComponent;
    
    private onFormSuccess: () => void;
    private onRemoveItem: () => void;

    constructor() {     
    }

    init(
        formId: string,
        popupId: string,
        popupElements: PopupElements, 
        popupComponent: PopupComponent, 
        onFormSuccess: () => void = null, 
        onDelete: () => void = null): void {
        this.formId = formId;
        this.popupElements = popupElements;
        this.popupComponent = popupComponent;
        this.onRemoveItem = onDelete;
        this.onFormSuccess = onFormSuccess;
        this.addEventListeners();
        this.popup = getPopup(<PopupOptions>{ id: popupId });   
    }

    private addEventListeners(): void {
        this.listenAddButton();
        this.listenEditButton();
        this.listenRemoveButton();
    }

    private listenAddButton(): void {
        if(this.popupElements.addItemButton) {
            this.popupElements.addItemButton.addEventListener('click', () => {
                this.openAddPopup(this.getQueryParameters(this.popupElements.addItemButton, this.popupComponent.addItemUrlParameters));
            });
        }
    }

    private listenEditButton(): void {
        this.popupElements.editButtons.forEach(editItemBtn => editItemBtn.addEventListener('click', () => {
            this.openEditPopup(this.getQueryParameters(editItemBtn, this.popupComponent.editItemUrlParameters))
        }));  
    }

    private listenRemoveButton(): void {
        this.popupElements.deleteButtons.forEach(removeItemBtn => removeItemBtn.addEventListener('click', async () => {
            const confirmDialog = new ConfirmDialog(() => {
                const queryParameters = this.getQueryParameters(removeItemBtn, this.popupComponent.removeItemUrlParameters);
                this.removeItem(queryParameters);
                this.onRemoveItem();
            });
            await confirmDialog.open();
        }));  
    }

    private getQueryParameters(elementWithAttribute: HTMLElement, queryParameters: QueryParameter[]): string {
        let url = '';
        
        queryParameters.forEach((par: QueryParameter) => {
            let value = elementWithAttribute.getAttribute(par.dataAttributeTargetValue);
            let fieldName = par.fieldName;

            url += (`&${fieldName}=${value}`);
        });

        return url;
    }

    private openAddPopup(queryParemeters: string): void {
        const url = `${getUrlWithoutQueryString()}?viewComponent=${this.popupComponent.displayComponentName}${queryParemeters}`;
        new HttpClient().fetch(url)
            .then(response => response.text())
            .then(body => this.popup.open(body))
            .then(() => this.subscribeFormSubmit())
            .catch(err => console.error(err));
    }

    private openEditPopup(queryParameters: string): void {
        const url = `${getUrlWithoutQueryString()}?viewComponent=${this.popupComponent.displayComponentName}${queryParameters}`;
        new HttpClient().fetch(url)
            .then(response => response.text())
            .then(body => this.popup.open(body))
            .then(() => {
                this.subscribeFormSubmit();
            })
            .catch(err => console.error(err));
    }

    private subscribeFormSubmit(): void {
        const form = document.getElementById(this.formId) as HTMLFormElement;
        //$.validator.unobtrusive.parse(form);
        
        form.addEventListener('submit', (event: Event) => {
            event.preventDefault();
            this.submitForm(form, event);
        })
    }

    private submitForm(formElement: HTMLFormElement, event: Event): void {
        const actionUrl = formElement.getAttribute('action');
        const form = new Form(actionUrl, formElement, 
            () => this.onFormSubmitSuccess(), 
            (html: string) => this.onModelError(html));

        form.process(event);
    }

    private onFormSubmitSuccess(): void {
        typeof this.onFormSuccess === 'function' && this.onFormSuccess();
        this.popup.close();
    }

    private onModelError(html: string): void {
        const viewcomponentName = `[data-component="${this.popupComponent.displayComponentName}"]`;
        const viewcomponent =  document.querySelector(viewcomponentName);
        viewcomponent.innerHTML = html;

        this.subscribeFormSubmit();
    }

    private removeItem(queryParameters: string): void {
        new HttpClient().fetch(`${window.location.origin}/${this.popupComponent.removeItemUrl}?${queryParameters}`, { method: 'DELETE' })
            .then(() => {
                typeof(this.onRemoveItem) === 'function' && this.onRemoveItem();
            })
            .catch(error => console.error(error));
    }
}
